<template>
    <div
        ref="cardRef"
        :class="['card', activeName === 'credit' && 'card--credit', activeName === 'vip' && 'card--vip', showBadge && 'recommend', (isActive || isMobile) && 'active']"
    >
        <div class="card-badge" v-if="showBadge">{{ badgeText }}</div>
        <div class="card-body">
            <div class="card-top">
                <div class="card-info">
                    <h4 class="card-info__title">{{ creditTitle }}</h4>
                    <p class="card-info__promo" v-if="promoText">{{ promoText }}</p>
                </div>

                <div class="card-kids" v-if="activeName === 'vip'">
                    <select class="card-kids__select" :value="kidsActive" @change="onKidChange">
                        <option value="1">{{ $t('1 child') }}</option>
                        <option value="2">{{ $t('2 children') }}</option>
                        <option value="3">{{ $t('3 children') }}</option>
                    </select>
                </div>

                <div class="card-price" v-if="activeName === 'credit'">
                    <div class="card-price__main">{{ displayPrice(priceInfo.price) }}</div>
                    <div class="card-price__sub" v-if="priceInfo.show_price || priceInfo.describe">
                        <span class="strike" v-if="priceInfo.show_price">{{ $t('Original price') }}：{{ displayPrice(priceInfo.show_price) }}</span>
                        <span v-if="priceInfo.describe"> {{ priceInfo.describe }}</span>
                    </div>
                </div>

                <div class="card-price" v-else>
                    <div class="card-price__main">{{ displayPrice(priceInfo.price) }}</div>
                    <div class="card-price__sub" v-if="vipSubVisible">
                        <template v-if="hasShowPrice">
                            <span>{{ $t('Original price') }}：</span>
                            <span class="strike">{{ displayPrice(priceInfo.show_price) }}</span>
                        </template>
                        <span class="month-price" v-if="hasMonthPrice">
                            {{ displayPrice(priceInfo.month_price) }}{{ $t('Per month unit') }}
                        </span>
                        <span v-if="priceInfo.describe"> {{ priceInfo.describe }}</span>
                    </div>
                </div>
            </div>

            <div class="card-bottom">
                <button class="card-btn" @click="handleClick">
                    <span class="card-btn_name">{{ activeName === 'vip' ? $t('Subscribe Now') : $t('Buy Now') }}</span>
                </button>

                <ul class="card-features">
                    <li v-for="(item, idx) in detailList" :key="idx">
                        <i class="check">✓</i>
                        <span class="text">{{ item.tips }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        priceInfo: {
            type: Object,
            default: () => ({}),
        },
        index: {
            type: Number,
            default: 0,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        isRecommend: {
            type: Boolean,
            default: false,
        },
        activeName: {
            type: String,
            default: 'credit',
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        kidsActive: {
            type: [String, Number],
            default: '1',
        },
    },
    data() {
        return {
            showDetail: false,
        };
    },
    computed: {
        formatQty() {
            return (val) => {
                if (val == null || val === '') return '';
                const num = Number(val);
                if (Number.isNaN(num)) return String(val);
                return Number.isInteger(num) ? String(num) : String(parseFloat(num));
            };
        },
        creditTitle() {
            if (this.activeName === 'vip') {
                const month = this.formatQty(this.priceInfo.month);
                const title = this.priceInfo.title || '';
                if (month) {
                    return this.$t('Vip card title')
                        .replace('{n}', month)
                        .replace('{title}', title);
                }
                return title;
            }
            // quantity = 充值课时，展示为「10课时」
            const qty = this.formatQty(this.priceInfo.quantity);
            if (qty) {
                const unit = this.priceInfo.price_unit || this.$t('Lessons unit');
                return `${qty}${unit}`;
            }
            return this.priceInfo.title;
        },
        promoText() {
            if (this.activeName !== 'credit') return '';
            // 赠送 extra_quantity，总计 total_quantity
            const gift = this.formatQty(this.priceInfo.extra_quantity);
            const total = this.formatQty(this.priceInfo.total_quantity);
            const parts = [];
            if (gift && Number(this.priceInfo.extra_quantity) > 0) {
                parts.push(this.$t('Gift lessons').replace('{n}', gift));
            }
            if (total) {
                parts.push(this.$t('Total lessons').replace('{n}', total));
            }
            if (parts.length) return parts.join(' ');
            return this.priceInfo.title_remark || this.priceInfo.title_tip || '';
        },
        detailList() {
            const list = [];
            if (this.activeName === 'credit') {
                ['tip1', 'tip2', 'tip3', 'tip4'].forEach((key) => {
                    if (this.priceInfo[key]) {
                        list.push(this.getListObj(this.priceInfo[key], key));
                    }
                });
            } else {
                list.push(...(this.priceInfo.plan_details || []).map(this.getListObj));
            }
            return list;
        },
        showBadge() {
            return this.isRecommend;
        },
        badgeText() {
            return this.$t('Recommended');
        },
        hasMonthPrice() {
            const val = this.priceInfo.month_price;
            return val != null && val !== '';
        },
        hasShowPrice() {
            const val = this.priceInfo.show_price;
            return val != null && val !== '';
        },
        vipSubVisible() {
            return !!(this.hasShowPrice || this.hasMonthPrice || this.priceInfo.describe);
        },
    },
    methods: {
        displayPrice(val) {
            if (val == null || val === '') return '';
            const raw = String(val).trim();
            if (/^[\d.]+$/.test(raw)) {
                return `$${raw}`;
            }
            return raw
                .replace(/¥|￥|CNY|RMB/gi, '$')
                .replace(/＄/g, '$');
        },
        handleClick() {
            this.$emit('btnClick');
        },
        onKidChange(e) {
            this.$emit('kidChange', e.target.value);
        },
        handleShowDetail() {
            this.showDetail = !this.showDetail;
        },
        getListObj(tips, key) {
            const iconClass = ['el-icon-star-on icon-yellow bolder', 'el-icon-check icon-green bolder'];
            const contentStringList = [this.$t('Refundable portion, Transaction fee will be charged for refund'), this.$t('Non-Refundable portion')];
            let content = '';
            if ('tip1' === key) {
                content = contentStringList[0];
            }
            if ('tip2' === key) {
                content = contentStringList[1];
            }
            if (this.index === 1) {
                if (key === 'tip3') {
                    content = contentStringList[1];
                }
            }
            return {
                icon: key && key === 'tip2' && this.index === 1 ? iconClass[0] : iconClass[1],
                content,
                tips,
            };
        },
    },
};
</script>

<style lang="less" scoped>
.card {
    --brand: #B50604;
    position: relative;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    box-shadow: 0 8px 28px rgba(26, 26, 26, 0.06);
    display: flex;
    flex-direction: column;
    font-family: "Microsoft YaHei", "Helvetica Neue", sans-serif;
    overflow: hidden;
    height: 560px;
    box-sizing: border-box;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    h4,
    h6,
    p,
    ul,
    li {
        margin: 0;
        padding: 0;
    }

    ul {
        list-style: none;
    }

    &.recommend {
        border-color: rgba(181, 6, 4, 0.45);
        box-shadow: 0 10px 32px rgba(181, 6, 4, 0.12);
    }

    &.active:not(.recommend) {
        border-color: #d0d0d0;
        box-shadow: 0 10px 28px rgba(26, 26, 26, 0.08);
    }

    &-badge {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
        min-width: 88px;
        height: 36px;
        padding: 0 18px 0 28px;
        background: var(--brand);
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        line-height: 36px;
        text-align: center;
        border-bottom-left-radius: 36px;
        box-sizing: border-box;
    }

    &-body {
        padding: 40px 24px 32px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        box-sizing: border-box;
        text-align: center;
    }

    &-top {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &-bottom {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: auto;
    }

    &-info {
        width: 100%;

        &__title {
            font-size: 26px;
            font-weight: 700;
            line-height: 1.35;
            color: #222;
            letter-spacing: 0.02em;
        }

        &__promo {
            margin-top: 10px;
            font-size: 14px;
            line-height: 1.5;
            color: var(--brand);
            font-weight: 500;
        }
    }

    &-kids {
        margin-top: 20px;
        width: 100%;
        display: flex;
        justify-content: center;

        &__select {
            width: 285px;
            max-width: 100%;
            height: 40px;
            padding: 0 36px 0 14px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            background-color: #fff;
            color: #333;
            font-size: 14px;
            outline: none;
            appearance: none;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23999999' d='M1 1l4 4 4-4'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 14px center;
            cursor: pointer;
            box-sizing: border-box;
            text-align: left;
        }
    }

    &-price {
        margin-top: 28px;
        width: 100%;

        &__main {
            font-size: 40px;
            font-weight: 700;
            line-height: 1.15;
            color: #111;
            letter-spacing: -0.02em;
        }

        &__sub {
            margin-top: 10px;
            font-size: 13px;
            line-height: 1.5;
            color: #999;

            .strike {
                text-decoration: line-through;
            }

            .month-price {
                margin-left: 6px;
                color: #999;
            }
        }
    }

    &-btn {
        width: calc(100% - 0px);
        max-width: 100%;
        height: 48px;
        margin: 0;
        background: var(--brand);
        border-radius: 6px;
        border: none;
        font-weight: 600;
        font-size: 16px;
        cursor: pointer;
        color: #fff;
        transition: background 0.2s ease, transform 0.15s ease;
        box-sizing: border-box;

        &:hover {
            background: #9c0503;
        }

        &:active {
            transform: scale(0.99);
        }

        &_name {
            color: #fff;
        }
    }

    &-features {
        margin-top: 48px;
        width: 227px;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        gap: 14px;
        text-align: left;

        li {
            display: flex;
            align-items: flex-start;
            gap: 8px;
        }

        .check {
            flex-shrink: 0;
            width: 14px;
            font-style: normal;
            font-size: 13px;
            font-weight: 700;
            line-height: 20px;
            color: var(--brand);
        }

        .text {
            font-size: 13px;
            line-height: 20px;
            color: #555;
        }
    }

    /* 课时充值：紧凑左对齐，去掉中间大空白 */
    &--credit {
        height: auto;
        min-height: 0;

        .card-body {
            padding: 32px 28px 28px;
            text-align: center;
            justify-content: flex-start;
            flex: none;
        }

        .card-top,
        .card-bottom {
            align-items: stretch;
            width: 100%;
            margin-top: 0;
        }

        .card-bottom {
            margin-top: 24px;
        }

        .card-info__title {
            font-size: 28px;
            font-weight: 700;
            color: #1a1a1a;
        }

        .card-info__promo {
            margin-top: 8px;
            font-size: 14px;
            color: var(--brand);
            font-weight: 500;
        }

        .card-price {
            margin-top: 20px;

            &__main {
                font-size: 42px;
                font-weight: 700;
                color: #111;
            }

            &__sub {
                margin-top: 8px;
                font-size: 13px;
                color: #999;
            }
        }

        .card-btn {
            margin-top: 0;
            height: 48px;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
        }

        .card-features {
            margin-top: 24px;
            width: 100%;
            gap: 12px;

            .text {
                font-size: 13px;
                color: #444;
            }
        }

        &.recommend {
            border: 1px solid var(--brand);
        }
    }

    /* 会员订阅：对齐设计稿 */
    &--vip {
        height: auto;
        min-height: 0;

        .card-body {
            padding: 36px 28px 32px;
            text-align: center;
            justify-content: flex-start;
            flex: none;
        }

        .card-top,
        .card-bottom {
            align-items: stretch;
            width: 100%;
            margin-top: 0;
        }

        .card-bottom {
            margin-top: 28px;
        }

        .card-info__title {
            font-size: 24px;
            font-weight: 700;
            line-height: 1.4;
            color: #1a1a1a;
        }

        .card-kids {
            margin-top: 20px;

            &__select {
                width: 100%;
                height: 44px;
                border-radius: 4px;
                border-color: #e0e0e0;
                color: #666;
                font-size: 14px;
            }
        }

        .card-price {
            margin-top: 24px;

            &__main {
                font-size: 40px;
                font-weight: 700;
                color: #111;
            }

            &__sub {
                margin-top: 8px;
                font-size: 13px;
                color: #999;

                .month-price {
                    margin-left: 4px;
                }
            }
        }

        .card-btn {
            height: 48px;
            border-radius: 6px;
            font-size: 16px;
            font-weight: 600;
        }

        .card-features {
            margin-top: 28px;
            width: 100%;
            gap: 12px;

            .check {
                color: var(--brand);
            }

            .text {
                font-size: 13px;
                line-height: 1.5;
                color: #444;
            }
        }

        &.recommend {
            border: 1px solid rgba(181, 6, 4, 0.55);
            box-shadow: 0 8px 28px rgba(181, 6, 4, 0.1);
        }
    }
}

@media screen and (max-width: @device) {
    .card {
        height: auto;
        min-height: 0;

        &:not(.card--credit):not(.card--vip) {
            min-height: 480px;
        }

        &-body {
            padding: 32px 18px 24px;
        }

        &-info__title {
            font-size: 22px;
        }

        &-price__main {
            font-size: 34px;
        }

        &-kids__select {
            width: 100%;
        }

        &-features {
            width: 100%;
            margin-top: 32px;
        }

        &-badge {
            min-width: 76px;
            height: 32px;
            line-height: 32px;
            font-size: 13px;
            padding: 0 14px 0 22px;
            border-bottom-left-radius: 32px;
        }

        &--credit {
            .card-body {
                padding: 28px 18px 24px;
            }

            .card-bottom {
                margin-top: 20px;
            }

            .card-features {
                margin-top: 20px;
            }
        }

        &--vip {
            .card-body {
                padding: 28px 18px 24px;
            }

            .card-info__title {
                font-size: 20px;
            }

            .card-price__main {
                font-size: 34px;
            }

            .card-bottom {
                margin-top: 22px;
            }

            .card-features {
                margin-top: 22px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PriceCard.vue